import { Module } from "vuex"
import { GiveawayState, GiveawayType, RootState } from "@/store/types"
import { createAsyncAction } from "../utils/createAsyncAction"
import { getGiveaways } from "../api"
import { GiveawayStatus } from "@/services/enums"

const giveawaysStore: Module<GiveawayState, RootState> = {
  namespaced: true,
  state: () => ({
    giveaways: {
      data: [],
      loading: true,
    },
  }),
  getters: {
    data: (state) => state.giveaways,
  },
  mutations: {
    SET_ASYNC_STATE<K extends keyof GiveawayState>(
      state: GiveawayState,
      {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        key,
        patch,
      }: {
        key: K
        patch: Partial<GiveawayState[K]>
      }
    ) {
      Object.assign(state.giveaways, patch)
    },
    ADD(state, giveaway: GiveawayType) {
      state.giveaways.data.unshift(giveaway)
    },
    UPDATE(state, giveaway: Partial<GiveawayType>) {
      if (giveaway.id) {
        const storeGiveaway = state.giveaways.data.find(
          (item) => item.id === giveaway.id
        )
        if (storeGiveaway) {
          Object.keys(giveaway).forEach((key) => {
            storeGiveaway[key as keyof GiveawayType] = giveaway[
              key as keyof GiveawayType
            ] as never
          })
          if (giveaway.status === GiveawayStatus.FINISHED && !giveaway.winner) {
            state.giveaways.data = state.giveaways.data.filter(
              (item) => item.id != giveaway.id
            )
          }
        }
      }
    },
  },
  actions: {
    getGiveaways: createAsyncAction(getGiveaways, "giveaways"),
  },
}

export default giveawaysStore
